import { useEffect, useState } from "react";
import { getVendors } from "../../utils/api";

export default function VendorSearch({ onSelect }) {
  const [query, setQuery] = useState("");
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    // Debounce so we're not hitting the backend on every keystroke.
    const timeout = setTimeout(() => {
      getVendors(query).then((results) => {
        if (!cancelled) {
          setVendors(results);
          setLoading(false);
        }
      });
    }, 200);

    return () => {
      cancelled = true;
      clearTimeout(timeout);
    };
  }, [query]);

  return (
    <div className="w-full max-w-xl flex flex-col gap-8">
      <div>
        <h2 className="font-display text-4xl font-bold tracking-tight">Payouts</h2>
        <p className="font-mono text-xs uppercase tracking-widest text-collectors-gray mt-2">
          Select a vendor to view their payout data
        </p>
      </div>

      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search vendors..."
        autoFocus
        className="bg-transparent border-solid border-b-2 border-collectors-light py-2 font-display
                text-2xl md:text-3xl font-medium text-collectors-black placeholder-collectors-light
                focus:outline-none focus:border-collectors-black transition-colors duration-300 rounded-none"
      />

      <div className="flex flex-col divide-y divide-collectors-light border-t border-b border-collectors-light">
        {loading && (
          <p className="font-mono text-xs uppercase tracking-widest text-collectors-gray py-6">
            Loading vendors...
          </p>
        )}

        {!loading && vendors.length === 0 && (
          <p className="font-mono text-xs uppercase tracking-widest text-collectors-gray py-6">
            No vendors found.
          </p>
        )}

        {!loading &&
          vendors.map((vendor) => (
            <button
              key={vendor.id}
              onClick={() => onSelect(vendor)}
              className="text-left py-4 flex justify-between items-center font-display text-xl
                      font-medium hover:opacity-60 transition-opacity"
            >
              {vendor.name}
              <span className="font-mono text-xs uppercase tracking-widest text-collectors-gray">
                View →
              </span>
            </button>
          ))}
      </div>
    </div>
  );
}